(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-articles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('woofin-editorial')) {
 customElements.define('woofin-editorial', class extends HTMLElement {
 connectedCallback() {
  if (this.initialized) { this.connect(); return; }
  this.initialized=true;
  this.list=this.querySelector('.ea-list'); this.main=this.querySelector('.ea-main'); this.rail=this.querySelector('.ea-sidebar'); this.layout=this.querySelector('.ea-layout');
  this.cards=Array.from(this.list.querySelectorAll(':scope > .ea-card'));
  this.placements=Array.from(this.querySelectorAll('[data-ea-placement]'));
  this.controls=this.querySelector('.ea-controls'); this.button=this.controls.querySelector('button');
  this.batch=Math.max(1,Math.min(50,Number(this.dataset.batch)||6));
  this.visible=this.dataset.mode==='all'?this.cards.length:Math.min(this.batch,this.cards.length);
  this.sidebars=this.placements.filter(node=>node.dataset.sidebar==='true').map(node=>{
   const marker=document.createElement('span'); marker.hidden=true; node.before(marker);
   const slot=document.createElement('div'); slot.className='ea-sidebar-slot';
   const sticky=document.createElement('div'); sticky.className='ea-sidebar-sticky'; sticky.style.setProperty('--ea-sticky-gap',(Number(node.dataset.stickyGap)||0)+'px'); slot.append(sticky);
   return {node,marker,slot,sticky,after:Number(node.dataset.after)||0};
  });
  this.reveal=manual=>{
   const previous=this.visible; this.visible=Math.min(this.visible+this.batch,this.cards.length); this.update();
   this.querySelector('.ea-status').textContent=(this.dataset.status||'[count] more articles loaded').replace('[count]',String(this.visible-previous));
   if(manual) this.cards[previous]?.querySelector('.ea-title a')?.focus({preventScroll:true});
  };
  this.button.addEventListener('click',()=>this.reveal(true));
  this.onBlock=event=>{
   const node=event.target.closest('[data-ea-placement]');
   if(node && this.contains(node)){this.visible=Math.max(this.visible,Number(node.dataset.after)||0);this.update();}
  };
  this.schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.arrange());};
  this.media=window.matchMedia('(min-width:1100px)'); this.mobileMedia=window.matchMedia('(max-width:749px)');
  this.update(); this.connect();
 }
 connect(){
  this.media.addEventListener('change',this.schedule); this.mobileMedia.addEventListener('change',this.schedule);
  this.addEventListener('load',this.schedule,true);
  document.addEventListener('shopify:block:select',this.onBlock);
  if('ResizeObserver' in window){this.resize=new ResizeObserver(this.schedule);this.resize.observe(this.main);this.placements.forEach(node=>this.resize.observe(node.querySelector('.ea-placement-inner')));}
  if(this.dataset.mode==='infinite' && 'IntersectionObserver' in window){
   this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)&&this.visible<this.cards.length&&!this.contains(document.activeElement))this.reveal(false);},{rootMargin:'160px'});
   this.observer.observe(this.controls);
  }
  this.schedule();
 }
 update(){
  this.cards.forEach((card,index)=>{card.hidden=index>=this.visible;});
  this.placements.forEach(node=>{node.hidden=Number(node.dataset.after)>this.visible;});
  this.controls.hidden=this.visible>=this.cards.length;
  this.arrange();
 }
 arrange(){
  this.placements.forEach(node=>{
   const device=this.media.matches?'desktop':this.mobileMedia.matches?'mobile':'tablet';
   node.hidden=Number(node.dataset.after)>this.visible || node.classList.contains('ea-hide-'+device) || (!this.media.matches && node.classList.contains('ea-placement--hide-mobile'));
  });
  if(!this.sidebars.length)return;
  const desktop=this.media.matches;
  const active=this.sidebars.filter(entry=>!entry.node.hidden).sort((a,b)=>a.after-b.after);
  this.layout.classList.toggle('ea-layout--sidebar',desktop&&active.length>0);
  this.rail.hidden=!desktop||!active.length;
  this.sidebars.forEach(entry=>{
   if(desktop){if(entry.node.parentNode!==entry.sticky){entry.sticky.append(entry.node);this.rail.append(entry.slot);}entry.slot.hidden=entry.node.hidden;}
   else {entry.marker.after(entry.node);entry.slot.remove();}
  });
  if(!desktop||!active.length)return;
  const top=this.main.getBoundingClientRect().top;
  const bottom=this.main.getBoundingClientRect().height;
  const positions=active.map(entry=>{
   if(entry.after===0)return 0;
   const next=this.cards[entry.after];
   const previous=this.cards[entry.after-1];
   return Math.max(0,(next&&!next.hidden?next.getBoundingClientRect().top:previous?.getBoundingClientRect().bottom||top)-top);
  });
  let lastEnd=0;
  active.forEach((entry,index)=>{
   const start=positions[index]; const end=index+1<active.length?positions[index+1]:bottom;
   this.rail.append(entry.slot);
   entry.slot.style.marginTop=Math.max(0,start-lastEnd)+'px';
   entry.slot.style.height=Math.max(0,end-start)+'px'; lastEnd=end;
  });
 }
 disconnectedCallback(){
  this.observer?.disconnect();this.resize?.disconnect();cancelAnimationFrame(this.frame);
  this.media?.removeEventListener('change',this.schedule); this.mobileMedia?.removeEventListener('change',this.schedule);this.removeEventListener('load',this.schedule,true);document.removeEventListener('shopify:block:select',this.onBlock);
 }
 });
}

  } catch(e) { console.error(e); }
})();
})();
